import React from "react";
import PropTypes from "prop-types";
import { LeavedReactions } from "./LeavedReactions.jsx";
import { ReactionTypesPalette } from "./ReactionTypesPalette.jsx";

export const Reactions = ({ parentType, parentId }) => (
  <div className="reactions disable_selection">
    <LeavedReactions
      parentType={parentType}
      parentId={parentId}
      className="tw-mr-1"
    />
    <ReactionTypesPalette
      parentType={parentType}
      parentId={parentId}
      className="reactions_picker reactions_palette"
    />
  </div>
);

Reactions.propTypes = {
  parentType: PropTypes.string.isRequired,
  parentId: PropTypes.number.isRequired,
};

Reactions.displayName = `Reactions`;
